/* ============================================================
   VEILN COLLECTION — Filter panel, grid density, category scroll
   ============================================================ */
(function () {
  'use strict';

  /* ---- Filter Panel ---- */
  function initFilterPanel() {
    var overlay  = document.querySelector('.veiln-filters-overlay');
    if (!overlay) return;

    var panel    = overlay.querySelector('.veiln-filters-panel');
    var backdrop = overlay.querySelector('.veiln-filters-backdrop');
    var openBtns = document.querySelectorAll('[data-veiln-open-filters]');
    var closeBtns = overlay.querySelectorAll('[data-veiln-close-filters]');

    function open() {
      overlay.classList.add('is-open');
      document.body.style.overflow = 'hidden';
      var firstFocus = panel.querySelector('button, input, select');
      if (firstFocus) setTimeout(function() { firstFocus.focus(); }, 350);
    }

    function close() {
      overlay.classList.remove('is-open');
      document.body.style.overflow = '';
    }

    openBtns.forEach(function(btn) { btn.addEventListener('click', open); });
    closeBtns.forEach(function(btn) { btn.addEventListener('click', close); });
    if (backdrop) backdrop.addEventListener('click', close);

    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && overlay.classList.contains('is-open')) close();
    });
  }

  /* ---- Filter Accordion ---- */
  function initFilterAccordion() {
    document.querySelectorAll('.veiln-filter-group__header').forEach(function(btn) {
      btn.addEventListener('click', function() {
        var group = btn.closest('.veiln-filter-group');
        var isOpen = group.classList.toggle('is-open');
        btn.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      });
    });
  }

  /* ---- Grid Density ---- */
  function initGridDensity() {
    var grid    = document.querySelector('.veiln-product-grid');
    var btns    = document.querySelectorAll('.veiln-subnav__density-btn');
    var storKey = 'veiln-density';
    if (!grid || !btns.length) return;

    function setDensity(val) {
      grid.setAttribute('data-density', val);
      btns.forEach(function(b) {
        b.classList.toggle('is-active', b.getAttribute('data-density') === val);
      });
      try { localStorage.setItem(storKey, val); } catch(e) {}
    }

    var saved;
    try { saved = localStorage.getItem(storKey); } catch(e) {}
    setDensity(saved || '3');

    btns.forEach(function(btn) {
      btn.addEventListener('click', function() {
        setDensity(btn.getAttribute('data-density'));
      });
    });
  }

  /* ---- Clear Filters ---- */
  function initClearFilters() {
    document.querySelectorAll('[data-veiln-clear-filters]').forEach(function(btn) {
      btn.addEventListener('click', function() {
        var url = new URL(window.location.href);
        var remove = [];
        url.searchParams.forEach(function(_, k) {
          if (k.startsWith('filter.')) remove.push(k);
        });
        remove.forEach(function(k) { url.searchParams.delete(k); });
        url.searchParams.delete('sort_by');
        window.location.href = url.toString();
      });
    });
  }

  /* ---- Scroll active category tab into view ---- */
  function initCategoryScroll() {
    var nav = document.querySelector('.veiln-subnav__categories');
    if (!nav) return;
    var active = nav.querySelector('.is-active');
    if (active) {
      requestAnimationFrame(function() {
        active.scrollIntoView({ behavior: 'instant', inline: 'center', block: 'nearest' });
      });
    }
  }

  /* ---- Hero video play/pause ---- */
  function initHeroVideos() {
    document.querySelectorAll('.veiln-coll-hero__video-ctrl').forEach(function(btn) {
      var panel = btn.closest('.veiln-coll-hero__panel');
      var video = panel && panel.querySelector('video');
      if (!video) return;
      btn.addEventListener('click', function(e) {
        e.preventDefault();
        if (video.paused) {
          video.play();
          btn.setAttribute('aria-label', 'Pause');
          btn.querySelector('.vc-play').style.display = 'none';
          btn.querySelector('.vc-pause').style.display = '';
        } else {
          video.pause();
          btn.setAttribute('aria-label', 'Play');
          btn.querySelector('.vc-play').style.display = '';
          btn.querySelector('.vc-pause').style.display = 'none';
        }
      });
    });
  }

  /* ---- Wishlist toggle (visual only) ---- */
  function initWishlist() {
    document.querySelectorAll('.veiln-card__wishlist').forEach(function(btn) {
      btn.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        btn.classList.toggle('is-saved');
        btn.setAttribute('aria-label', btn.classList.contains('is-saved') ? 'Remove from wishlist' : 'Save to wishlist');
      });
    });
  }

  /* ---- Init ---- */
  document.addEventListener('DOMContentLoaded', function() {
    initFilterPanel();
    initFilterAccordion();
    initGridDensity();
    initClearFilters();
    initCategoryScroll();
    initHeroVideos();
    initWishlist();
  });
})();
